<template>
  <dialog-email
    ref="dialog-email"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="data"
    :isLoading="isLoading"
    @on-submit-email="handlerSubmit"
  ></dialog-email>
</template>

<script>
import { toDate } from '@/utils/filters'
import { createList } from '@/utils/templates'
import { createParams } from '@/utils/dynamic'
import { ModelEmailNewInstruction } from '@/models/RepairExchangeOrder'
import { api } from '@/services/api'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'DialogNewInstruction',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      isLoading: false,
      id: null,
      subject: null,
      requestMainData: null,
      requestLogData: null,
      data: {},
      contentMap: {},
      cb: () => {}
    }
  },
  created () {
    this.$bus.$on('on-new-instruction-repair-order', this.show)
  },
  beforeDestroy () {
    this.$bus.$off('on-new-instruction-repair-order', this.show)
  },
  computed: {
    contentKey () {
      return 'instruction-to-support'
    }
  },
  methods: {
    loadData () {
      this.isLoading = true
      return Promise.all([
        this.loadMainData(),
        this.loadLogData()
      ])
        .then(() => {
          this.createMapData()
          this.createEmailData()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadMainData () {
      const params = createParams({
        select: [
          'id', 'baxpo as baxPO', 'part.partNumber as partNumber', 'partSN', 'lastInfo',
          'rfq2.supplierContact.name as salesOrderContactName', 'rfq2.supplierContact.email as supplierContactEmail'
        ].join(','),
        filter: `id == ${this.id}`
      })
      return api
        .get(`RepairExchangeOrderFollowUps/GetAllDynamic`, { params })
        .then(({ data }) => {
          if (data.value[0]) {
            this.requestMainData = data.value[0]
          } else {
            throw Error()
          }
        })
    },
    loadLogData () {
      const params = createParams({
        select: 'id,repairExchangeOrderFollowUpID,entryDate,employeeID,description,isEmployeeEntry,isRead,employee.name as employeeName',
        filter: `repairExchangeOrderFollowUpID == ${this.id}`,
        orderBy: `id desc`
      })
      return api
        .get(`RepairExchangeOrderFollowUpLogs/GetAllDynamic`, { params })
        .then(({ data }) => {
          this.requestLogData = data.value
            .map((logItem) => {
              return {
                ...logItem,
                entryDate: toDate(logItem.entryDate)
              }
            })
        })
    },
    createMapData () {
      this.contentMap = this.copyObjectProps(new ModelEmailNewInstruction(), {
        ...this.requestMainData,
        subject: this.subject,
        listActivities: createList(this.requestLogData, '{employeeName}, {entryDate}, {description}')
      })
    },
    createEmailData () {
      const { baxPO } = this.requestMainData
      let subject = `${baxPO} ${this.L10n('new-instruction')}`
      let emailToList = ['support@bel-airexpress.com', 'logistics@bel-airexpress.com']

      this.data = {
        subject,
        emailToList
      }
    },
    show ({ subject, id }, cb) {
      this.cb = cb
      this.id = id
      this.subject = subject
      this.$refs['dialog-email'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog-email'].hide()
      this.isLoading = false
    },
    handlerSubmit (data) {
      this.isLoading = true
      ServiceEmailMessages.send(data)
        .then(() => {
          if (typeof this.cb === 'function') {
            this.cb({ ...data, supplierContactName: this.contentMap.salesOrderContactName })
          }
          this.hide()
        })
        .catch((err) => {
          this.isLoading = false
          this.requestErrorHandler(err)
        })
    }
  }
}
</script>
